import { useMutation, useQueryClient } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { ReviewExerciseInput } from '../types';

import { clientExercisesKeys } from './useExercises';

export function useReviewExercise(clientId: string, clientExerciseId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ReviewExerciseInput) =>
      exercisesService.review(clientId, clientExerciseId, input),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: clientExercisesKeys.operation('by-client', { clientId }),
      });
      void qc.invalidateQueries({
        queryKey: clientExercisesKeys.operation('detail', {
          clientId,
          cxId: clientExerciseId,
        }),
      });
    },
  });
}
